import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminNavbar1 from "components/Navbars/AdminNavbar1.jsx";
import AuthNavbar from "components/Navbars/AuthNavbar.jsx";
import Footer from "components/Footer/Footer.jsx";

// import routes from "../routes-minimal.js";
import routes from "routes";

class Pages extends React.Component {
  componentDidMount() {
    // Remove PerfectScrollbar: rely on native scroll
  }
  componentWillUnmount() {
    // No PerfectScrollbar to destroy
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/sub") {
        const Component = prop.component;
        return (
          <Route
            path={prop.layout + prop.path}
            element={<Component />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <>
        <AdminNavbar1 {...this.props} handleMiniClick={this.handleMiniClick} />
        <div className="wrapper-full-page" ref="fullPages">
          <Routes>{this.getRoutes(routes)}</Routes>
          <Footer fluid />
        </div>
      </>
    );
  }
}

export default Pages;
